import React from "react";
import { t } from "ttag";

import { LocalContactForm } from "../CRMForm/LocalContactForm";
import { CenteredModal } from "../CenteredModal";
import { ButtonSecondary } from "../Clickables";

import styles from "./index.module.scss";

export const ScheduleVisitModal = ({
    trigger = <ButtonSecondary>{t`Schedule a Visit`}</ButtonSecondary>,
}: {
    trigger?: React.ReactNode;
}) => {
    const headingId = React.useId();

    return (
        <CenteredModal
            trigger={trigger}
            theme="black"
            panelClassName={styles.panel}
            labelledBy={headingId}
        >
            <h2 id={headingId} className={styles.heading}>
                {t`Connect with your SKS Representative`}
            </h2>
            <p className={styles.subheading}>
                {t`Start planning your dream kitchen today! Complete the form below to arrange a visit to our showroom.`}
            </p>
            <div className={styles.form}>
                <LocalContactForm
                    layout="full-width"
                    custom_submit_url={null}
                />
            </div>
        </CenteredModal>
    );
};
